import styled from "styled-components";
import { motion } from "framer-motion";

import colors from "../../assets/css/colors";

export const Container = styled(motion.div)`
    padding-top: 89px;

    @media (max-width: 500px) {
        padding-top: 20px;
    }
`

export const Title = styled.h1`
    color: ${colors.primary};
    letter-spacing: 0;
    text-align: left;
    font-size: 39px;
`;

export const SubTitle = styled.p`
    color: ${colors.grayDark};
    font-size: 14px;
`;